
import request from "./request";
const rootPath =
  process.env.NODE_ENV === "development"
    ? "/api"
    : "https://language.phenxie.com/api";
export function custom(pageNum, pageSize, params ) {
  return request({
    url:
      rootPath +
      `/custom/mmse/listpage?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: "post",
    data: params,
  });
}
export function addcustom( params ) {
  return request({
    url:
      rootPath +
      `/custom/mmse/add`,
    method: "post",
    data: params,
  });
}
export function reomveCustom( id ) {
  return request({
    url:
      rootPath +
      `/custom/mmse/remove?id=${id}`,
    method: "post",
  });
}
export function updateCustom( params ) {
  return request({
    url:
      rootPath +
      `/custom/mmse/update`,
    method: "post",
    data: params,
  });
}
export function addCustomItem( params ) {
  return request({
    url:
      rootPath +
      `/mmse/question/add`,
    method: "post",
    data: params,
  });
}
export function getCustomRecord(params) {
  return request({
    url:
      rootPath +
      `/mmse/question/listpage?pageNum=1&pageSize=999`,
    method: "post",
    data: params,
  });
}
export function getAnalysisRecord(pageNum,pageSize,params) {
  return request({
    url:
      rootPath +
      `/audio/analysis/listpage?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: "post",
    data: params,
  });
}
export function getCustomUpdown(params) {
  return request({
    url:
      rootPath +
      `/mmse/question/updown`,
    method: "post",
    data: params,
  });
}
export function reomveCustomRecord(id) {
  return request({
    url:
      rootPath +
      `/mmse/question/remove?id=${id}`,
    method: "post",
  });
}
export function updateCustomRecord(params) {
  return request({
    url:
      rootPath +
      `/mmse/question/update`,
    method: "post",
    data: params,
  });
}
export function publishCustomRecord(params) {
  return request({
    url:
      rootPath +
      `/custom/mmse/publish`,
    method: "post",
    data: params,
  });
}
export function queryExists(params) {
  return request({
    url:
      rootPath +
      `/authorize/info/exists?userId=${params.userId}&mmseId=${params.mmseId}`,
    method: "get",
    data: params,
  });
}
export function addAuthorize(params) {
  return request({
    url:
      rootPath +
      `/authorize/info/add`,
    method: "post",
    data: params,
  });
}
export function getListbox(params) {
  return request({
    url:  rootPath +
      `/custom/mmse/listbox`,
    method: "post",
    data: params,
  });
}
export function uploadImage(params) {
  return request({
    url: rootPath + `/examine/uploadImage`,
    method: "post",
    data: params,
    headers: { "content-type": "application/x-www-form-urlencoded" }
  });
}
export function uploadFileV2(params) {
  return request({
    url: rootPath + `/examine/uploadAudioV2`,
    method: "post",
    data: params,
    headers: { "content-type": "application/x-www-form-urlencoded" }
  });
}
export function uploadFileRich(params) {
  return request({
    url: rootPath + `/examine/upload-img`,
    method: "post",
    data: params,
    headers: { "content-type": "application/x-www-form-urlencoded" }
  });
}
export function saveCustomTest(params) {
  return request({
    url:  rootPath +
      `/mmse/answer/add`,
    method: "post",
    data: params,
  });
}
export function updateCustomTest(params) {
  return request({
    url:  rootPath +
      `/mmse/answer/update`,
    method: "post",
    data: params,
  });
}
export function getAnswerDetail(id) {
  return request({
    url:  rootPath +
      `/mmse/answer/${id}`,
    method: "get",
  });
}
export function getMmseListpage(pageNum,pageSize,params) {
  return request({
    url:  rootPath +
      `/mmse/answer/listpage?pageNum=${pageNum}&pageSize=${pageSize}`,
    method: "post",
    data: params,
  });
}
export function deletemmse(id) {
  return request({
    url:  rootPath +
      `/mmse/answer/remove?id=${id}`,
    method: "post",
  });
}